const bulletin = document.querySelector(".js-bulletin"),
        bulletinClose = document.querySelector(".js-bulletin-close"),
        headerWrapper = document.querySelector('.header__wrapper'),
        bulletinTextLg = document.querySelector('.js-bulletin-large-text');

        

function showBulletin() {
    gsap.to(bulletin, {
        y: 0,
        duration: 0.2
    });
}

function removeBulletin() {
    let bulletinHeight = bulletin.offsetHeight;
    gsap.to(bulletin, {
        y: -bulletinHeight,
        //ease: Linear.easeNone,
        duration: 0.4
    });
}

function removeBulletinPermanently() {
    let bulletinHeight = bulletin.offsetHeight;
    gsap.to(bulletin, {
        y: -bulletinHeight,
        autoAlpha: 0,
        //ease: Linear.easeNone,
        duration: 0.4,
        display:"none"
    });
}

function setHeaderTop() {
    let bulletinHeight = bulletin.offsetHeight;
    gsap.to(header, {
        y: bulletinHeight,
        duration: 0.4
    });
    gsap.to(headerWrapper, {
        marginTop: bulletinHeight,
        duration: 0.4
    });
    gsap.to(menuButton, {
        y: bulletinHeight,
        duration: 0.4
    });
}

function removeHeaderTop() {
    gsap.to(header, {
        y: 0,
        duration: 0.4
    });
    gsap.to(headerWrapper, {
        marginTop: 0,
        duration: 0.4
    });
    gsap.to(menuButton, {
        y: 0,
        duration: 0.4
    });
}

function animateLargeText() {
    const largeText= gsap.timeline({repeat: -1});
    largeText.to(bulletinTextLg, {
        x: '10%',
        duration: 10
    })
    largeText.to(bulletinTextLg, {
        x: 0,
        duration: 10
    })
}

if (typeof bulletin != "undefined" && bulletin != null) {
    let isActive = true;
    let bulletinHeight = bulletin.offsetHeight;
    

    if(isActive) {

        if (typeof bulletinTextLg != "undefined" && bulletinTextLg != null) {
            animateLargeText()
        }

        setHeaderTop();

        bulletinClose.addEventListener("click", () => {
            isActive = false;
            removeBulletinPermanently();
            removeHeaderTop();
        });

        window.addEventListener('scroll', () => {
            if (window.scrollY > window.innerHeight / 4) {
               // removeBulletin();
                isActive = false;
                removeHeaderTop();
            } else if (window.scrollY == 0) {
               // showBulletin();
                isActive = true;
                setHeaderTop();

            }
        })
    } 
   
}
